export default __webpack_public_path__ + "f907c74300c7b7ce71339045198c7842.woff2";